import { useEffect, useState } from "react";
import api from "@/lib/api";

const FALLBACK_SUPPORT_EMAIL = "testing@ssmobileonline.com";
let _cache = null;
let _promise = null;

export async function fetchPublicConfig() {
  if (_cache) return _cache;
  if (!_promise) {
    _promise = api
      .get("/public-config")
      .then(({ data }) => {
        _cache = data || {};
        return _cache;
      })
      .catch(() => ({ support_email: FALLBACK_SUPPORT_EMAIL }));
  }
  return _promise;
}

export function useSupportEmail() {
  const [email, setEmail] = useState(_cache?.support_email || FALLBACK_SUPPORT_EMAIL);
  useEffect(() => {
    let mounted = true;
    fetchPublicConfig().then((c) => {
      if (mounted && c?.support_email) setEmail(c.support_email);
    });
    return () => { mounted = false; };
  }, []);
  return email;
}
